import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/chrome': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M131.5 217.5l-76.4-117.4c47.6-59.2 119-91.8 192-92.1 42.3-0.3 85.5 10.5 124.8 33.2 43.4 25.2 76.4 61.4 97.4 103l-205.3-10.8c-58.1-3.4-113.4 29.3-132.5 84.1zM164.4 256c0-46.3 37.4-83.6 83.6-83.6s83.6 37.4 83.6 83.6-37.4 83.6-83.6 83.6-83.6-37.4-83.6-83.6zM479.3 166.8c43.5 111.9 0 241.9-107.4 303.9-43.4 25.2-91.3 35.4-137.8 32.9l112.1-172.4c31.9-49 31.3-112.9-6.6-157.2zM133.7 303.6c26.3 51.7 81.9 83.3 139.5 72.5l-63.7 124.8c-118.7-18.2-209.5-120.9-209.5-244.9 0-50.1 14.9-96.9 40.4-135.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/chrome.js
// module id = 752
// module chunks = 0